/* eslint-disable */
import React, { useEffect, useState, useRef, Fragment } from "react";
// import { Col, Container, Row, Stack, Button, Form, Image, Card, Accordion } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import * as types from "../../constants/CrmActionTypes";

import "../crmComponents/Leadtabs.css";
import { Link, Outlet } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";
import {
  appUserAccountActivity, editAccountData
} from "../../redux/actions/accountAction";
import { Listbox, Dialog, Transition } from '@headlessui/react'
import { useDispatch, useSelector } from "react-redux";
import Loading from "../assetLibComponents/Loading";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon, ChevronDownIcon, GlobeAltIcon, HandThumbUpIcon, PhoneIcon, UserCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { UserIcon } from "@heroicons/react/24/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const AccountDetail = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const cancelButtonRef = useRef(null)
  const navigate = useNavigate();
  const accountDetails = useSelector(
    (state) => state.account?.account_details
  );
  const account_detail_left = useSelector(
    (state) => state.account?.account_details?.account_response
  );
  const userDetails = useSelector(
    (state) => state.crmLeads.userActivityDetails
  );
  const isLoading = useSelector((state) => state.crmLeads.loading);

  // const taskList = useSelector((state) => state.crmLeads.tasksList);

  const authToken = props.authToken;
  // const pageFrom = props.pageFrom;

  // const [stage, setStage] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [openRightBar, setOpenRightBar] = useState(false);
  const [designation, setDesignation] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [editDetail, setEditDetail] = useState(false);
  const [userData, setUserData] = useState([]);
  const [stage, setStage] = useState("");

  const getChars = (str) => {
    if (str === "") {
      return;
    }
    const firstLetters = str
      .split(" ")
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
    return firstLetters;
  };

  useEffect(() => {
    props.pageTypeHandler("Account Mangement");
    if (id !== undefined) {
      dispatch(appUserAccountActivity(authToken, id ,null));
    }
  }, []);
  
  useEffect(() => {
    if (id !== undefined) {
      dispatch(appUserAccountActivity(authToken, id ,editDetail));
    }
  }, [window.location.pathname,editDetail])
  

  useEffect(() => {
    return () => {
      dispatch({ type: types.USER_ACTIVITY_DETAILS, payload: null });
      dispatch({ type: types.DETAIL_UPDATED_DATA, payload: null });
    };
  }, []);

  useEffect(async() => {
    setName(accountDetails?.details?.name);
    if (account_detail_left?.length > 0) {
      await account_detail_left.map(async(obj, o_ind) => {
        if (obj?.options?.length > 0 && obj.values !== null) {
          const objData = await obj.options.find(option => option.id == obj.values)
          obj.values = objData;
        }
        return obj
      })
    }    
    setUserData(account_detail_left);
  }, [account_detail_left]);

  // const updateStage = (e) => {
  //   setStage(e);
  //   if (userDetails?.data?.leadstages) {
  //     let stageNum = userDetails.data.leadstages.filter((item) => {
  //       if (e === item.lead_stage) {
  //         return item.id;
  //       }
  //     });
  //     dispatch(updateLeadsStage(authToken, stageNum[0].id, id));
  //   }
  // };

  const handleRoute = () => {
    navigate("/Account");
  };
  
  const handleEditorStatus = (value) => {
    setEditDetail(value);
  }
  
  const backToDetail = () => {
    setName(accountDetails?.details?.name);
    setEditDetail(false);
  }
  
  const handleRightBar = () => {
    setOpenRightBar(false);
  }
  
  const handleSubmitLead = async (payload) => {
    let companyNameReal, companyWebsiteReal;
    const payloadNew = await payload.map((obj) => {
      if (obj?.options?.length > 0) {
        obj.values = obj?.values?.id?.toString() || null;
        obj.options = [];
      }
      const { id, display, ...rest } = obj;
      return rest;
    });
    await dispatch(editAccountData(authToken, id, payloadNew));
    setEditDetail(false);
  }
  
  const handleDynamicFields = async (e, id, len) => {
    let data = [...account_detail_left];
    await data.map((obj) => {
      if (id === null && obj.display === "Company") {
        obj.values = e.target.value;
        setName(e.target.value);
      }
      if (id === obj.id && len === 0) {
        obj.values = e.target.value;
      }
      if (id === obj.id && len !== 0) {
        obj.values = e;
      }
      return obj;
    });
    setUserData(data);
  }

  return (
    <>
      {isLoading && <Loading />}
      {accountDetails !== null && (
        <div className="detailed-lead pt-[4rem] grid grid-cols-12">
          <div className="col-span-3 max-sm:col-span-12 px-6">
            {" "}
            <div className="mt-4">
              <div className="mt-2 flex cursor-pointer">
                <Icon.ChevronLeft
                  onClick={handleRoute}
                  className="py-1"
                  style={{
                    fontSize: 25,
                    color: "#6B7280",
                    fontWeight: "bold",
                  }}
                />
                <div onClick={handleRoute} className="my-auto text-sm leading-5 font-medium text-gray-500">
                  Accounts
                </div>
                {editDetail !== true ? <>
                  <span onClick={()=>{handleEditorStatus(true)}} className="flex ml-auto mr-0 items-center justify-center border hover:text-[var(--brand-primary)] hover:border-[var(--brand-primary)] border-gray-300 px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                    <Icon.Pencil className="cursor-pointer text-gray-600 text-[16px]" />
                  </span>
                </>
                :
                <>
                  <span onClick={backToDetail} className="flex ml-auto mr-1 items-center justify-center border hover:text-[var(--brand-primary)] border-[gray] px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                    <Icon.X className="cursor-pointer text-[gray] text-[16px]" />
                  </span>
                    <span onClick={() => { handleSubmitLead(userData) }} className="flex items-center justify-center border hover:text-[var(--brand-primary)] border-[green] px-2.5 py-1 rounded-md border-solid cursor-pointer ">
                    <Icon.Check2 className="cursor-pointer text-[green] text-[16px]" />
                  </span>
                </>
                }
              </div>
              <div className="my-2">
                <div className="flex items-center">
                  <div className="mr-2">
                    <div className="circle">
                      {getChars(name || accountDetails?.details?.name || "Unknown" )}
                    </div>
                  </div>
                  <div className="pt-1 w-full max-sm:ml-3 max-sm:border-none max-sm:border-white">
                    {/* Lead Name */}
                      <div
                        className={
                          "details-input-parent " + (editDetail && "w-100")
                        }
                      >
                        {editDetail !== true ? (
                          <div title={name || accountDetails?.details?.name} className="h-[35px] w-[65%] text-2xl cursor-default overflow-hidden text-ellipsis whitespace-nowrap capitalize leading-9 font-semibold text-gray-900">
                            {name || accountDetails?.details?.name || ""}
                          </div>
                        ) : (
                          <div className="first-div h-[35px]">
                            <div>
                              <input
                                className="text-2xl leading-9 font-semibold text-gray-900 w-[80%]"
                                type="text"
                                value={name}
                                onChange={(e) => {
                                  handleDynamicFields(e, null);
                                }}
                                autoFocus
                              />
                            </div>
                          </div>
                        )}
                      </div>
                  </div>
                  <div onClick={()=>{setOpenRightBar(true);}} className="animate-pulse sm:hidden bg-[var(--brand-primary)] p-2 rounded-[10px] ml-auto mr-0">
                    <Icon.GraphUpArrow className="text-[22px] text-[#ffffff]" />
                  </div>
                </div>
              </div>
              <hr className="mt-3 max-sm:hidden" />
              <div className="h-[50vh] listing max-sm:border-b max-sm:border-t max-sm:border-gray-200 overflow-y-auto max-sm:h-[20vh]">
                {/* Lead Email */}
                {userData?.length > 0 && userData.map((data, d_index)=>{
                    return (
                      <>{data.display !== "Company" && data.display !== "Created Date" && data.display !== "Edited Date" && <div key={d_index} className="mt-3 lh-lg details-section">
                        <div className="text-xs leading-4 font-normal text-gray-700">
                          {data.display}
                        </div>
                        <div
                          className="grid grid-cols-12"
                        >
                          {editDetail !== true ? (
                            <div className="h-[25px] col-span-8 text-sm leading-5 font-normal text-gray-900">
                              {data?.options?.length > 0 ? data?.values?.option_value : data.values}
                            </div>
                          ) : (
                            <div className="h-auto col-span-9 fw-normal">
                              <div>
                                {data?.options?.length === 0 ? <input
                                  className="w-full text-sm leading-5 font-normal text-gray-900"
                                  type={data.type}
                                  value={data.values}
                                  onChange={(e) => {
                                    handleDynamicFields(e, data.id, data?.options?.length);
                                  }}
                                  />
                                    :
                                  <>
                                    <div className="w-full text-sm leading-5 font-normal text-gray-900">                                        
                                      <Listbox
                                        value={data.values}
                                        onChange={(e) => { handleDynamicFields(e, data.id, data?.options?.length) }}>
                                        {({ open }) => (
                                          <>
                                            <div className="relative">
                                              <Listbox.Button className="relative h-[25px] mr-[5px] rounded-none border-b-[#ced4da] border-b border-solid w-full bg-white text-left text-gray-900 shadow-sm ring-1 ring-inset focus:outline-none cursor-pointer sm:text-sm sm:leading-6">
                                                <span className="block truncate">{data?.values?.option_value}</span>
                                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                  <ChevronDownIcon className="h-4 w-4 text-gray-400" aria-hidden="true" />
                                                </span>
                                              </Listbox.Button>

                                              <Transition
                                                show={open}
                                                as={Fragment}
                                                leave="transition ease-in duration-100"
                                                leaveFrom="opacity-100"
                                                leaveTo="opacity-0"
                                              >
                                                <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                  {data?.options?.map((option) => (
                                                    <Listbox.Option
                                                      key={option.id}
                                                      className={({ active }) =>
                                                        classNames(
                                                          active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                          'relative cursor-default select-none py-2 pl-2 pr-4'
                                                        )
                                                      }
                                                      value={option}
                                                    >
                                                      {({ selected, active }) => (
                                                        <>
                                                          <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                            {option.option_value}
                                                          </span>

                                                          {/* {selected ? (
                                                            <span
                                                              className={classNames(
                                                                active ? 'text-white' : 'text-indigo-600',
                                                                'absolute inset-y-0 left-0 flex items-center pl-1.5'
                                                              )}
                                                            >
                                                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                            </span>
                                                          ) : null} */}
                                                        </>
                                                      )}
                                                    </Listbox.Option>
                                                  ))}
                                                </Listbox.Options>
                                              </Transition>
                                            </div>
                                          </>
                                        )}
                                      </Listbox>
                                      
                                    </div>
                                  </>}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>}</>
                    )
                })}
              </div>
            </div>
            <div className="max-sm:flex max-sm:justify-start">
                <hr className="my-3" />

                {/* Last Created */}
                {(accountDetails?.details?.created_date?.length > 0) && (
                  <div className="mt-3">
                    <div className="text-xs leading-4 font-normal text-gray-700">
                      Created On
                    </div>
                    <div className="text-sm leading-5 font-normal text-gray-900">
                      {accountDetails?.details?.created_date || "28th Sep 2023"}
                    </div>
                  </div>
                )}
                {/* Last Edited */}
                {(accountDetails?.details?.edited_date?.length > 0) && (
                  <div className="mt-3 max-sm:ml-10">
                    <div className="text-xs leading-4 font-normal text-gray-700">
                      Updated On
                    </div>
                    <div className="text-sm leading-5 font-normal text-gray-900">
                      {accountDetails?.details?.edited_date || "28th Sep 2023"}
                    </div>
                  </div>
                )}
              </div>
          </div>

          <div className="col-span-6 max-sm:col-span-12 bg-gray-100 ">
            <div className="setup-category">
              <div className="p-0">
                <div>
                  <ul>
                    <li
                      className={
                        window.location.pathname ===
                        `/Account/companyDetail/${id}`
                          ? "list-active"
                          : ""
                      }
                      onClick={() => {
                        navigate(`/Account/companyDetail/${id}`);
                      }}
                    >
                      <span>Detailed History</span>
                    </li>
                    {accountDetails?.is_follow && <li
                      className={
                        window.location.pathname ===
                        `/Account/intel/${id}`
                          ? "list-active"
                          : ""
                      }
                      onClick={() => {
                        navigate(`/Account/intel/${id}`);
                      }}
                    >
                      <span>Intel</span>
                    </li>}
                    {/* <li className={window.location.pathname.includes('/home/setup/microsite') ? 'list-active' : '' } onClick={() => { navigate('/setup/microsite') }}><span>Notes</span></li> */}
                    {/* <li className={window.location.pathname.includes('add-mail') ? 'list-active' : ''} onClick={() => { navigate(`/Lead-Management/leadDetail/${id}/add-mail`);}}><span>E-mails</span></li> */}
                    {/* <li className={window.location.pathname.includes('/home/setup/mobileApp') ? 'list-active' : '' } onClick={() => { navigate('/setup/mobileApp')}}><span>Meetings</span></li> */}
                    {/* <li className={window.location.pathname.includes('/home/setup/crm') ? 'list-active' : '' } onClick={() => { navigate('/setup/crm')}}><span>CRM</span></li>
                                <li className={window.location.pathname.includes('/home/setup/userManagement') ? 'list-active' : '' } onClick={() => { navigate('/setup/userManagement'); refreshPage(); }}><span>User Management</span></li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="middlePiece">
              <Outlet></Outlet>
            </div>
            {/* <Emails />  */}

            {/* <AddMail/> */}
          </div>

          <div className="col-span-3 max-sm:hidden md:col-span-3">
            <div className="mb-1">
              <div className="w-full">
                <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
                  {/* <Disclosure as="div" className="my-2">
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white p-3 text-left text-sm font-medium text-gray-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75">
                          <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                            Insights
                          </span>
                          <ChevronUpIcon
                            className={`${
                              open ? "" : "rotate-180 transform"
                            } h-5 w-5 text-gray-500`}
                          />
                        </Disclosure.Button>
                        <Disclosure.Panel className="h-[24vh] overflow-y-auto listing">
                          <div className="flex flex-col rounded-md bg-cards p-4 mt-2">
                            <div className="flex">
                              <UserCircleIcon className="h-5 w-5" />
                              <div className="text-[#212121] font-[700] font-[14px] ml-2">
                                Summary
                              </div>
                            </div>
                            <div className="text-[#212121] font-[500] text-[12px] mt-2 ml-4">
                              Akash has visited SalesPanda 2 times. Akash has
                              asked 4 prompts. Akash has filled in his Name and
                              E-mail ID. Akash has asked about SalesPanda and
                              how it could help his insurance company sell more
                              effectively. He has shown interest in SalesPanda’s
                              Channel Marketing features.
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                  <hr /> */}
                  <Disclosure as="div" className="my-2">
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white p-3 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                          <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                            Upcoming Meetings
                          </span>
                          <ChevronUpIcon
                            className={`${
                              open ? "" : "rotate-180 transform"
                            } h-5 w-5 text-gray-500`}
                          />
                        </Disclosure.Button>
                        <Disclosure.Panel className="max-h-[15vh] overflow-y-auto listing">
                          {false && userDetails?.data?.upcoming_meeting?.length > 0 && userDetails?.data?.upcoming_meeting.map((meet,m_index) => {
                            return (
                              <div className="relative flex flex-col mt-2 rounded-md bg-cards p-4">
                                <div className="flex">
                                  <PhoneIcon className="h-4 w-4" />
                                  <div className="text-[#212121] font-[14px] ml-2">
                                  Call scheduled
                                  </div>
                                </div>
                                <div className="text-[#212121] font-[500] text-[12px] mt-2 ml-4">
                                {meet.time}, {meet.date}
                                </div>
                                <span className="absolute capitalize text-[10px] bg-[#19945914] border text-[#199459] px-[5px] py-px rounded-md border-solid border-[#199459] right-3 top-[25%]">{ meet.duration }</span>
                              </div>
                            )
                          })}
                          { true && <div className="relative flex flex-col mt-2 rounded-md bg-cards p-4">
                            <div className="flex justify-center">
                              <div className="text-[#212121] font-[14px] ml-2">
                                No Meeting Scheduled
                              </div>
                            </div>
                          </div>}
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                  <hr />
                  <Disclosure as="div" className="my-2">
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white p-3 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                          <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                            Contacts
                          </span>
                          <ChevronUpIcon
                            className={`${
                              open ? "" : "rotate-180 transform"
                            } h-5 w-5 text-gray-500`}
                          />
                        </Disclosure.Button>
                        <Disclosure.Panel className="h-[24vh] listing overflow-y-auto px-4 pt-4 pb-2 text-sm text-gray-500">
                          <div className="flex flex-wrap">
                           {accountDetails?.contact_list.map((contact, c_index) => {
                            return (
                              <div className="flex flex-col w-[16%] mr-3 mb-1 my-3 cursor-pointer"
                                onClick={() => {
                                  navigate(
                                    `/Lead-Management/leadDetail/${contact.id}`
                                  );
                                }}
                              >
                                <div className="rounded-full text-center bg-gray-200 p-3 text-[15.75px] leading-[13.2px] text-[#212121] font-[400] uppercase">
                                    {contact.symbol || "U"}
                                </div>
                                <div className="mt-2 w-95% overflow-hidden text-ellipsis whitespace-nowrap text-center leading-3 text-[10px] font-[400] text-[#212121]">{contact.name || "Unknown"}</div>
                              </div>
                            )})}
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Preview modal  */}
        <Transition.Root show={openRightBar} as={Fragment}>
          <Dialog as="div" className="relative z-50" onClose={handleRightBar}>
            <Transition.Child
              as={Fragment}
              enter="ease-in-out duration-500"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in-out duration-500"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-hidden">
              <div className="absolute inset-0 overflow-hidden">
                <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <Dialog.Panel className="pointer-events-auto relative w-screen max-w-lg">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-in-out duration-500"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-500"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <div className="absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4">
                          <button
                            type="button"
                            className="relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                            onClick={handleRightBar}
                          >
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </Transition.Child>
                        <div className="flex h-full flex-col p-0 bg-white shadow-xl">
                          <div className="relative flex-1 px-0 sm:px-0">
                              <div className="col-span-12">
                                  <div className="mb-1">
                                    <div className="w-full">
                                      <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
                                        {/* <Disclosure as="div" className="my-2">
                                          {({ open }) => (
                                            <>
                                              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white p-3 text-left text-sm font-medium text-gray-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75">
                                                <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                                                  Insights
                                                </span>
                                                <ChevronUpIcon
                                                  className={`${
                                                    open ? "" : "rotate-180 transform"
                                                  } h-5 w-5 text-gray-500`}
                                                />
                                              </Disclosure.Button>
                                              <Disclosure.Panel className="h-[24vh] overflow-y-auto listing">
                                                <div className="flex flex-col rounded-md bg-cards p-4 mt-2">
                                                  <div className="flex">
                                                    <UserCircleIcon className="h-5 w-5" />
                                                    <div className="text-[#212121] font-[700] font-[14px] ml-2">
                                                      Summary
                                                    </div>
                                                  </div>
                                                  <div className="text-[#212121] font-[500] text-[12px] mt-2 ml-4">
                                                    Akash has visited SalesPanda 2 times. Akash has
                                                    asked 4 prompts. Akash has filled in his Name and
                                                    E-mail ID. Akash has asked about SalesPanda and
                                                    how it could help his insurance company sell more
                                                    effectively. He has shown interest in SalesPanda’s
                                                    Channel Marketing features.
                                                  </div>
                                                </div>
                                              </Disclosure.Panel>
                                            </>
                                          )}
                                        </Disclosure> */}
                                        <hr />
                                        <Disclosure as="div" className="my-2">
                                          {({ open }) => (
                                            <>
                                              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white p-3 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                                <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                                                  Upcoming Meetings
                                                </span>
                                                <ChevronUpIcon
                                                  className={`${
                                                    open ? "" : "rotate-180 transform"
                                                  } h-5 w-5 text-gray-500`}
                                                />
                                              </Disclosure.Button>
                                              <Disclosure.Panel className="max-h-[15vh] overflow-y-auto listing">
                                                { (false || userDetails?.data?.upcoming_meeting?.length > 0) && userDetails?.data?.upcoming_meeting.map((meet,m_index) => {
                                                  return (
                                                    <div className="relative flex flex-col mt-2 rounded-md bg-cards p-4">
                                                      <div className="flex">
                                                        <PhoneIcon className="h-4 w-4" />
                                                        <div className="text-[#212121] font-[14px] ml-2">
                                                        Call scheduled
                                                        </div>
                                                      </div>
                                                      <div className="text-[#212121] font-[500] text-[12px] mt-2 ml-4">
                                                      {meet.time}, {meet.date}
                                                      </div>
                                                      <span className="absolute capitalize text-[10px] bg-[#19945914] border text-[#199459] px-[5px] py-px rounded-md border-solid border-[#199459] right-3 top-[25%]">{ meet.duration }</span>
                                                    </div>
                                                  )
                                                })}
                                                {true && <div className="relative flex flex-col mt-2 rounded-md bg-cards p-4">
                                                  <div className="flex justify-center">
                                                    <div className="text-[#212121] font-[14px] ml-2">
                                                      No Meeting Scheduled
                                                    </div>
                                                  </div>
                                                </div>}
                                              </Disclosure.Panel>
                                            </>
                                          )}
                                        </Disclosure>
                                        <hr />
                                        <Disclosure as="div" className="my-2">
                                          {({ open }) => (
                                            <>
                                              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white p-3 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                                <span className="text-[#212121] text-[12px] font-[700] leading-[16px] font-inter">
                                                  Contacts
                                                </span>
                                                <ChevronUpIcon
                                                  className={`${
                                                    open ? "" : "rotate-180 transform"
                                                  } h-5 w-5 text-gray-500`}
                                                />
                                              </Disclosure.Button>
                                              <Disclosure.Panel className="h-[24vh] listing overflow-y-auto px-4 pt-4 pb-2 text-sm text-gray-500">
                                                <div className="flex flex-wrap">
                                                {accountDetails?.contact_list.map((contact, c_index) => {
                                                  return (
                                                    <div className="flex flex-col w-[16%] mr-3 mb-1 my-3 cursor-pointer"
                                                      onClick={() => {
                                                        navigate(
                                                          `/Account/companyDetail/${contact.id}`
                                                        );
                                                      }}
                                                    >
                                                      <div className="rounded-full text-center bg-gray-200 p-3 text-[15.75px] leading-[13.2px] text-[#212121] font-[400] uppercase">
                                                          {contact.symbol || "U"}
                                                      </div>
                                                      <div className="mt-2 text-center leading-3 text-[10px] font-[400] text-[#212121]">{contact.name || "Unknown"}</div>
                                                    </div>
                                                  )})}
                                                </div>
                                              </Disclosure.Panel>
                                            </>
                                          )}
                                        </Disclosure>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                          </div>
                        </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
    </>
  );
};

export default AccountDetail;
